const baseColors = {
  backgroundColor: '#F0F0F0',
  buttonColor: '#333333',
  buttonTextColor: '#F0F0F0',
  pageTextColor: '#333333',
  socialButtonsColor: '#333333',
};

export default baseColors;
